import type { TokenTransfer } from 'types/api/tokenTransfer';

export default function getNftTransferImageUrl(
  total: TokenTransfer['total'],
  options?: { tokenId?: string; instanceImageUrl?: string | null },
): string | null | undefined {
  if ('image_url' in total && total.image_url) {
    return total.image_url;
  }

  if (
    options?.instanceImageUrl &&
    options?.tokenId &&
    'token_id' in total &&
    total.token_id !== null &&
    String(options.tokenId) === String(total.token_id)
  ) {
    return options.instanceImageUrl;
  }

  return null;
}
